import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const updateRoleSlice = createSlice({
  name: "updateRole",
  initialState,
  reducers: {
    updateRoleRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    updateRoleRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    updateRoleRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
  },
});

export const {
  updateRoleRequested,
  updateRoleRequestFailed,
  updateRoleRequestSucceeded,
} = updateRoleSlice.actions;

export default updateRoleSlice.reducer;
